import { UPDATE, CLEAR } from 'actions/payments'
export default (state = { paid: false }, action) => {
  switch (action.type) {
    case UPDATE: return { paid: action.result.paid }
    case CLEAR: return { paid: false }
    default: return state
  }
}
